import React, { Component } from "react";

import { Doughnut } from "react-chartjs-2";

class CircularProgress extends Component {
  render() {
    const data = {
      datasets: [
        {
          data: [this.props.progress, 100 - this.props.progress],
          backgroundColor: ["#02517D", "#00000011"],
          hoverBackgroundColor: ["#02517D", "#00000011"],
          hoverBorderColor: ["rgba(0, 0, 0, 0)", "rgba(0, 0, 0, 0)"],
          borderColor: ["rgba(0, 0, 0, 0)", "rgba(0, 0, 0, 0)"]
        }
      ]
    };

    return (
      <Doughnut
        data={data}
        options={{
          legend: {
            display: false
          },
          tooltips: {
            enabled: false
          },
          cutoutPercentage: 85,
          maintainAspectRatio: false
        }}
      />
    );
  }
}

export default CircularProgress;
